import { getIsRtl } from './../locale/i18n';

const letters = () => (getIsRtl() ? 'אבגדהוזחטיכלמנסעפצקרשת' : 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz');

export default letters;
